import React, {useState, useEffect} from 'react';
import "../../../css/pages/ourservices.scss";
import service from "../../../images/ourservices/service.jpg";
import servicepattern from "../../../images/ourservices/servicepattern.png";
import buy from "../../../images/ourservices/how-we-help/buy.jpg";
import financial from "../../../images/ourservices/how-we-help/financial.jpg";
import market from "../../../images/ourservices/how-we-help/market.jpg";
import smbeducation from "../../../images/ourservices/how-we-help/smbeducation.jpg";
import owner from "../../../images/ourservices/who-we-help/owner.png";
import broker from "../../../images/ourservices/who-we-help/broker.png";
import institution from "../../../images/ourservices/who-we-help/institution.png";
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';

function Ourservices() {
    const history = useHistory();

    return(
        <div className='ourservices-container'>
            <div className='ourservices-content'> 
                <div className='row value-container'>
                    <div className='col-8'>
                        <div className='value-content'>
                            <h3>Our Services</h3>
                            <h4>We Value Small and Medium Businesses</h4>
                            <p>With our unique approach, we are able to help millions of small and medium business learn the value of their business for the first time.</p>
                            <p>No longer is the value of a business determined by someone with a vested interest in making it higher or lower than it really is.</p>
                        </div>
                    </div>
                    <div className='col-4'>
                        <img src={service} alt="service image" />
                    </div>
                </div>
                <div className='how-we-help-container'>
                    <h3>How We Help</h3>
                    <div className='row buy-sell-content'>
                        <div className='col-2'>
                            <img src={buy} alt="buy image" />
                        </div>
                        <div className='col-10'>
                            <h4>Buy/Sell</h4>
                            <p>The buy/sell platform allows a business owner or broker to list a business for sale or make public that they are open to offers and for prospective buyers to see businesses that are for sale and then make contact with the buyer.</p>
                        </div>
                    </div>
                    <div className='row financial-content'>
                        <div className='col-2'>
                            <img src={financial} alt="financial image" />
                        </div>
                        <div className='col-10'>
                            <h4>Financial Services</h4>
                            <p>The buy/sell platform allows a business owner or broker to list a business for sale or make public that they are open to offers and for prospective buyers to see businesses that are for sale and then make contact with the buyer.</p>  
                            <ul>
                                <li>Lending options that allow owners to have access to loans under $100,000.</li>
                                <li>Fractional ownership empowers SMB owners to raise funds while developing customer loyalty. Members of the public can simultaneously build individual wealth and support local economic development through opportunities to make small investments locally.</li>
                                <li>Businesses can allow their customers and others in the community to donate money to support their businesses during temporary challenging times.</li>
                                <li>Earned Wage Service allows business owners to offer employees access to wages they have earned rather than waiting until the official payday.</li>
                            </ul>               
                        </div>
                    </div>
                    <div className='row marketplace-content'>
                        <div className='col-2'>
                            <img src={market} alt="marketplace image" />
                        </div>
                        <div className='col-10'>
                            <h4>MarketPlace</h4>
                            <ul>
                                <li>With millions of small and medium business owners and thousands of professionals active on the platform, there is no better place to do business with or as an SMB.</li>
                                <li>A dynamic marketplace with an assortment of offerings from professionals across the small business spectrum.</li>
                            </ul>
                        </div>
                    </div>
                    <div className='row smb-education-content'>
                        <div className='col-2'>
                            <img src={smbeducation} alt="smbeducation image" />
                        </div>
                        <div className='col-10'>
                            <h4>SMB Education</h4>
                            <p>The RS11 SMB Education Platform helps small and medium businesses develop the knowledge and skills to increase the value of their business. We have several ways to help business owners get the information they need.</p>      
                            <ul>
                                <li>Online videos and podcasts - produced by RS11 business experts and by 3rd party professionals.</li>
                                <li>Coaching and consulting - where professionals offer coaching and consulting services to business owners.</li>
                                <li>Communities - join a cohort of businesses custom selected based on your current situation, needs, objectives, and goals</li>
                            </ul>       
                        </div>
                    </div>
                </div>
                <div className='who-we-help-container'>
                    <img className='pattern' src={servicepattern} alt="patternB"></img>
                    <h3>Who we Help?</h3>
                    <div className='row who-we-help-content'>
                        <div className='col-4'>
                            <div className='owner-content'>
                                <div className='owner-image'>
                                    <img src={owner} alt="owner image" />
                                </div>
                                <h5>As a Business Owner</h5>
                                <p>You can learn what you have. Get a fair and accurate assessment of what your business is worth.</p>
                                <p>With that information, you can better plan your future - or just your next step.</p>
                                <p>Is now is the time to</p>
                                <ul>
                                    <li>Offer your business for sale?</li>
                                    <li>Invest in your business with a Small Business Loan?</li>
                                    <li>Rest assured that you’ve built a solid foundation for you and your family’s future?</li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-4'>
                            <div className='broker-content'>
                                <div className='broker-image'>
                                    <img src={broker} alt="broker image" />
                                </div>
                                <h5>As a Business Broker</h5>
                                <p>You can see millions of businesses and their value, so you can spend more time helping buyers and sellers make better and quicker decisions.</p>
                                <p>As a registered broker, you’ll have access to special tools to help you reach the people ready to explore opportunities, instead of when it’s too late to make the necessary changes to get the most of their investments.</p>
                            </div>
                        </div>
                        <div className='col-4'>
                            <div className='institution-content'>
                                <div className='institution-image'>
                                    <img src={institution} alt="institution image" />
                                </div>
                                <h5>As a Financial Institution</h5>
                                <p>Take some of the risks out of lending to small and medium businesses by knowing what the business is worth. Just like knowing the value of a home helps to underwrite a 2nd mortgage, knowing the value of a business will help you make smarter loans.</p>
                                <p>As a registered small business lender, you’ll have access to powerful tools to help you close more loans faster and with more confidence.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Ourservices;

